module.exports = __webpack_public_path__ + "img/meteor.e78f21b4.png";